import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20with%20dramatic%20composition%2C%20beautiful%20anime%20characters%20in%20fantasy%20setting%2C%20warm%20golden%20and%20rose%20tones%2C%20soft%20atmospheric%20lighting%2C%20ethereal%20mood%2C%20cinematic%20wide%20shot%2C%20artistic%20painterly%20style%2C%20gentle%20color%20gradient%2C%20dreamy%20bokeh%20effect%2C%20elegant%20composition%20with%20flowing%20fabric%20and%20floating%20particles%2C%20high%20detail%20illustration%20quality&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="韩漫之家 - 专业韩漫在线阅读平台"
          title="韩漫之家 - 韩漫在线阅读"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <div className="animate-fade-in-up">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight tracking-wide">
              {t('home:hero.title1', '发现最精彩的')}
              <br />
              <span className="text-accent-500">{t('home:hero.title2', '韩漫世界')}</span>
            </h1>
          </div>

          <p className="animate-fade-in-up animate-delay-100 mt-6 text-sm md:text-base text-white/80 max-w-2xl leading-relaxed">
            {t('home:hero.subtitle', '海量精品韩漫，免费下拉式阅读，智能加载，流畅舒适')}
          </p>

          <div className="animate-fade-in-up animate-delay-200 mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/category/all"
              className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-white rounded-full px-8 py-3.5 text-sm md:text-base font-medium transition-all duration-300 cursor-pointer hover:scale-105"
            >
              {t('home:hero.cta', '开始探索')}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white rounded-full px-8 py-3.5 text-sm md:text-base font-medium transition-all duration-300 cursor-pointer border border-white/30"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-fade-in animate-delay-500">
        <div className="flex flex-col items-center gap-2 text-white/60">
          <span className="text-xs">{t('home:hero.scrollHint', '向下滚动了解更多')}</span>
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-down-line text-sm animate-bounce"></i>
          </div>
        </div>
      </div>
    </section>
  );
}